"use client";

import React, { useEffect } from "react";
import PortfolioResponsiveDisplays from "@/app/components/PortfolioResponsiveDisplays/PortfolioResponsiveDisplays";
import WebsiteLogo from "@/app/components/WebsiteLogo/websitelogo";
import { WebsiteSubtitle } from "@/app/components/WebsiteSubtitle/WebsiteSubtitle";
import FirstBlockAbout from "@/components/common/FirstBlockAbout";
import ShopifyLogo from "@/app/components/icons/ShopifyLogo";
import LiquidLogo from "@/app/components/icons/liquidLogo";
import HTML5Logo from "@/app/components/icons/HTML5Logo";
import CSS3Logo from "@/app/components/icons/CSS3Logo";
import JSLogo from "@/app/components/icons/JSLogo";
import FigmaLogo from "@/app/components/icons/figmaLogo";
import PortfolioTechStack from "@/app/components/PortfolioTechStack/PortfolioTechStack";
import PortfolioColorscheme from "@/app/components/PortfolioColorscheme/PortfolioColorscheme";
import PortfolioTypography from "@/app/components/PortfolioTypography/PortfolioTypography";

export default function PlumbingMarket() {
  const primaryColor = "#2c2d2c";
  useEffect(() => {
    const link = document.createElement("link");
    document.head.appendChild(link);

    return () => {
      document.head.removeChild(link);
    };
  }, []);

  return (
    <>
      <section className="flex flex-col gap-[100px] my-[35px]">
        <div>
          <WebsiteLogo imageSrc="https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FPlumbingMarket%2FPlumbingMarketlogo.webp?alt=media&token=ac951029-5c3e-4e1f-979d-fbd989dbcf26" />
          <FirstBlockAbout
            media={{
              type: "image",
              src: "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FPlumbingMarket%2Fplumbingmarketbackgroundimage.webp?alt=media&token=2d8127f3-82c6-4c2e-8fc7-ac274d438bb7",
            }}
            primaryColor={primaryColor}
          />
          <WebsiteSubtitle
            textAlign="left"
            text="Plumbing Market, a key supplier of kitchen and bathroom products, required a transformative overhaul of its online presence to unlock its E-commerce potential. We partnered with them to execute a comprehensive digital strategy, involving a complete website remake, advanced technological integrations, and a robust growth plan, taking full control of their online business operations. <br /> <br />
Complete Website & E-commerce Platform Rebuild: We initiated a full redesign of their website, developing a new, user-centric theme and robust architecture. A core part of this was migrating and structuring an extensive catalog of over 100,000 products.
Advanced Custom Development: <br /> <br />

Shopify Customization: We implemented sophisticated custom logic and unique functionalities within their Shopify store to cater to specific business needs and enhance the user experience. <br />
Next.js & Firebase Expansion: To further scale their operations and offer tailored experiences, we created custom additional storefronts and specialized pages utilizing Next.js and Firebase, ensuring high performance and flexibility. <br /> <br />

Bespoke CMS Development: We engineered a proprietary Content Management System (CMS) built on Next.js, specifically designed to streamline their sales processes and content management for these custom sections. <br /> <br />

Explosive Growth & Ongoing Management:
SEO & Traffic Generation: Through intensive and targeted SEO strategies across their vast product range and content pages, we dramatically increased their organic search traffic from approximately 10 to an average of 500 unique visitors per day. <br /> <br />

Sales & Revenue Amplification: Our integrated approach to platform enhancement, user experience optimization, and strategic digital marketing resulted in a monumental uplift in sales, growing monthly revenue from $40,000 to $340,000 CAD. <br /> <br />
Comprehensive Online Business Control: We assumed full control of their online business arm, managing all aspects of advertisement, ongoing SEO, website operations, and overall digital strategy to sustain and build upon this success. <br /> <br />

This multifaceted project transformed Plumbing Market from a business with a nascent online presence into a high-performing e-commerce leader in their sector. By rebuilding their digital infrastructure from the ground up with advanced custom solutions and driving targeted growth initiatives, we achieved an exceptional increase in visibility, user engagement, and, most importantly, a nearly 9x growth in monthly revenue. Our ongoing management ensures Plumbing Market continues to thrive and dominate in the competitive online plumbing supplies space."
            title="Deliverables"
            tags={[
              "TYPOGRAPHY",
              "COLORSCHEME",
              "RESPONSIVE DESIGN",
              "TECH STACK",
            ]}
            buttonHref="https://www.plumbingmarket.ca/"
          />
        </div>

        <PortfolioTypography
          typographyData={[
            {
              headline:
                "Excellence in Cleaning Services: delivering unmatched quality and meticulous attention to detail.",
              fontFamily: "Montserrat",
              fontSize: "38px",
              letterSpacing: "0%",
              lineHeight: "auto",
              textColor: "#2c2d2c",
            },
          ]}
          primaryColor={primaryColor}
        />
        <PortfolioColorscheme
          ColorschemeData={[
            {
              title: "Main color",
              color: "#2C2D2C",
              rgb: "#2C2D2C",
              textColor: "#FFFFFF",
            },
            {
              title: "White",
              color: "#FFFFFF",
              rgb: "#FFFFFF",
              textColor: "#2c2d2c",
            },
            {
              title: "Red",
              color: "#E92020",
              rgb: "#E92020",
              textColor: "#fffff",
            },
          ]}
          primaryColor={primaryColor}
        />
        <PortfolioResponsiveDisplays
          ResponsiveDisplaysData={[
            {
              type: "image",
              content:
                "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FPlumbingMarket%2Fplumbingpc.webp?alt=media&token=17e462b1-aa66-40f9-ba8f-06f69795d80b",
            },
            {
              type: "image",
              content:
                "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FPlumbingMarket%2Fplumbingipad.webp?alt=media&token=9fe42b56-77c3-4837-acf1-dc9c4d65f8f5",
            },
            {
              type: "image",
              content:
                "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FPlumbingMarket%2Fplumbingmobile.webp?alt=media&token=c5062a78-5dcd-4950-8961-c81487e39fd1",
            },
          ]}
          primaryColor={primaryColor}
        />
        <PortfolioTechStack
          primaryColor={primaryColor}
          blocks={[
            {
              title: "Design",
              icons: [<FigmaLogo key="figma" />],
              opacity: 5,
            },
            {
              title: "Layout Development",
              icons: [
                <HTML5Logo key="html5" />,
                <CSS3Logo key="css3" />,
                <JSLogo key="js" />,
              ],
              opacity: 12,
            },
            {
              title: "Theme Development",
              icons: [<LiquidLogo key="liquid" />],
              opacity: 25,
            },
            {
              title: "Publishing",
              icons: [<ShopifyLogo key="shopify" />],
              opacity: 30,
            },
          ]}
        />
      </section>
    </>
  );
}
